import { showLog } from "./log";

export function formatDate(date) {
  showLog("FormatDate Masuk formatDate");
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
}

export function formatMinutes(date) {
  showLog("FormatDate Masuk formatMinutes");
  var d = new Date(date);
  return d.getHours() + ":" + d.getMinutes();
}

export function formatSeconds(date) {
  showLog("FormatDate Masuk formatSeconds");
  var d = new Date(date);
  return d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
}

export function formatMilliSeconds(date) {
  showLog("FormatDate Masuk formatMilliSeconds");
  var d = new Date(date);
  return (
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds() +
    ":" +
    d.getMilliseconds()
  );
}
